import React from 'react';
import  aRiEarthFill  from './files/earth.png';
import  at  from './files/edit.png';
import logo from './files/logo.jpeg';
import './Info.css'

export function Info() {
    return (
        <div className='container'>
            <div className='layout'>
                <div className='info-boxes'>
                    <div className='box'>
                        <div className='info'>
                            <div className='title'>НПП - БЪЛГАРЕ</div>
                            <div>Национална политическа партия БЪЛГАРЕ е създадедна да защитава интересите на българския народ, да насърчава националното единство и гордост, и да работи за икономическо развитие, социална справедливост и запазване на културното наследство на България. Нашата цел е да създадем по-добро бъдеще за всички българи чрез честност, отговорност и ангажираност към обществото.
                            </div>
                        </div>
                        <div className='info-pic'><img className='logo-img' src={logo} alt='logo' /></div>
                    </div>
                    <div className='box'>
                        <div className='info'>
                            <div className='title'>УЧРЕДЯВАНЕ</div>
                            <div>На 11 МАЙ 2007г  в гр. Хасково е учредена НАЦИОНАЛНА ПОЛИТИЧЕСКА ПАРТИЯ "БЪЛГАРЕ".
                            </div>
                        </div>
                        <div className='info-pic'>
                            <div className='icon-box'>
                                <img className='icon' src={at} alt='pic'/>
                                
                            </div>
                        </div>
                    </div>

                    <div className='box'>
                        <div className='info'>
                            <div className='title'>ЦЕЛИ НА ПАРТИЯТА</div>
                            <li className='list'>
                                Утвърждаване на върховенство на Конституцията и законите, на пазарната конкуренция и икономическия растеж
                            </li>
                            <li className='list'>
                                Провеждане на силно местно самоуправление
                            </li>
                            <li className='list'>
                                Гарантиране неприкосновеността на законно придобитата частна собственост
                            </li>
                            <li className='list'>
                                Вътрешна и външна политика, насочена към нуждите на обикновения човек
                            </li>
                            <li className='list'>
                                Преодоляване на разликата между българските граждани и гражданите на другите европейски държави в стандарта и качеството на живот
                            </li>
                            <li className='list'>
                                Създаване от град Хасково на регионален център за трансгранично сътрудничество
                            </li>


                        </div>
                        <div className='info-pic'>
                            <div className='icon-box'>
                               
                                <img className='icon' src={aRiEarthFill} alt='pic'/>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    );
}

export default Info